import { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { ArrowLeft, Image } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_0890dc80-6146-4c2d-b11f-fa0b2de6d70b/artifacts/ekzdqal8_image.png";
const API_BASE = process.env.REACT_APP_BACKEND_URL;

const categories = [
  { value: "all", label: "Semua" },
  { value: "potong", label: "Model Potong" },
  { value: "warna", label: "Hair Color" },
  { value: "kids", label: "Kids Style" },
];

export default function GalleryPage() {
  const [items, setItems] = useState([]);
  const [searchParams] = useSearchParams();
  const [filter, setFilter] = useState(searchParams.get("cat") || "all");
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => { api.get("/gallery").then(r => setItems(r.data)).catch(() => {}); }, []);

  const filtered = filter === "all" ? items : items.filter(i => i.category === filter);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <nav className="fixed w-full z-50 bg-[#050505]/90 backdrop-blur-xl border-b border-[#262626]/50">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-14">
          <div className="flex items-center gap-3">
            <Link to="/"><img src={LOGO} alt="FI" className="w-8 h-8 rounded-full" /></Link>
            <span className="font-heading text-sm font-bold uppercase tracking-wider">Galeri</span>
          </div>
          <Link to="/" className="text-sm text-gray-400 hover:text-white flex items-center gap-1" data-testid="gallery-back"><ArrowLeft size={14} /> Beranda</Link>
        </div>
      </nav>

      <div className="pt-20 pb-16 px-6 md:px-12 lg:px-24 max-w-7xl mx-auto">
        <div className="mb-8">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#E60000] mb-2">GALERI</p>
          <h1 className="font-heading text-4xl font-bold uppercase tracking-tight" data-testid="gallery-title">Model Rambut & Hair Color</h1>
          <p className="text-gray-400 mt-2">Pilih model rambut atau warna rambut sebagai referensi Anda</p>
        </div>

        <div className="flex gap-2 mb-8" data-testid="gallery-filters">
          {categories.map(c => (
            <button key={c.value} onClick={() => setFilter(c.value)} className={`px-4 py-2 text-xs font-bold uppercase tracking-wider border transition-colors ${filter === c.value ? "border-[#E60000] bg-[#E60000]/10 text-[#E60000]" : "border-[#262626] text-gray-400 hover:border-[#E60000]"}`} data-testid={`gallery-filter-${c.value}`}>
              {c.label}
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <div className="text-center py-24">
            <Image size={48} className="text-gray-600 mx-auto mb-4" />
            <p className="text-gray-400">Belum ada item galeri. Admin dapat menambahkan melalui panel admin.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="gallery-grid">
            {filtered.map(item => (
              <button type="button" onClick={() => setLightbox({ src: item.image_url && item.image_url.startsWith("fi-barbershop") ? `${API_BASE}/api/files/${item.image_url}` : item.image_url, name: item.name, description: item.description, category: item.category })} key={item.id} className="bg-[#0F0F0F] border border-[#262626] hover:border-[#E60000] transition-all group overflow-hidden text-left" data-testid={`gallery-item-${item.id}`}>
                <div className="aspect-[3/4] bg-[#1A1A1A] flex items-center justify-center overflow-hidden">
                  {item.image_url ? (
                    <img src={item.image_url.startsWith("fi-barbershop") ? `${API_BASE}/api/files/${item.image_url}` : item.image_url} alt={item.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  ) : (
                    <Image size={48} className="text-gray-600" />
                  )}
                </div>
                <div className="p-4">
                  <h3 className="text-white font-semibold">{item.name}</h3>
                  <p className="text-gray-500 text-xs mt-1">{item.description}</p>
                  <span className="text-[10px] text-[#E60000] uppercase font-bold mt-2 inline-block">{item.category}</span>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Lightbox */}
      <Dialog open={!!lightbox} onOpenChange={(o) => { if (!o) setLightbox(null); }}>
        <DialogContent className="bg-[#0A0A0A] border-[#262626] text-white max-w-3xl rounded-none p-0 overflow-hidden" data-testid="gallery-lightbox">
          {lightbox && (
            <div>
              <div className="bg-[#050505] flex items-center justify-center" style={{ maxHeight: "70vh" }}>
                <img src={lightbox.src} alt={lightbox.name || "Detail"} className="w-full h-auto object-contain" style={{ maxHeight: "70vh" }} />
              </div>
              <div className="p-5 border-t border-[#262626]">
                {lightbox.category && (
                  <span className="inline-block text-[10px] font-bold uppercase tracking-[0.2em] text-[#E60000] mb-2">
                    {lightbox.category === "kids" ? "Kids Style" : lightbox.category === "warna" ? "Hair Color" : "Model Potong"}
                  </span>
                )}
                {lightbox.name && <h3 className="font-heading text-xl font-bold uppercase tracking-tight mb-1">{lightbox.name}</h3>}
                {lightbox.description && <p className="text-sm text-gray-400 leading-relaxed">{lightbox.description}</p>}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
